import { CartLineItems, PurchaseItem } from '../interfaces';
import closeIcon from '/asset/close.svg';
import { formatCurrency, removeSkuPrefix } from '../utils';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';
import { updatePurchaseCartAsync } from '../store/purchaseSlice';
import AddCircle from '/asset/add-square.svg';
import MinusCircle from '/asset/minus-square.svg';

export default function Cart({ cart }: { cart: PurchaseItem[] }) {
  const dispatch: AppDispatch = useDispatch();
  const { checkoutResponse, anonymousCheckoutResponse } = useSelector(
    (state: RootState) => state.purchase
  );
  const updateCartItemQuantity = (cartItem: PurchaseItem) => {
    // eslint-disable-next-line prefer-const
    let thisCart = [...cart];
    // eslint-disable-next-line prefer-const
    let cartLineItems: CartLineItems[] = [];
    const {
      quantity,
      productVariantId,
      specialRequest,
      image,
      description,
      code,
      name,
      unitPrice,
    } = cartItem;
    const index = thisCart.findIndex(
      (item) => item.productVariantId === productVariantId
    );
    if (quantity > 0) {
      if (index < 0) {
        thisCart.push({
          quantity: 1,
          code: code,
          name: name,
          unitPrice: unitPrice,
          description: description,
          rewardsValue: 0,
          image: image,
          productVariantId: productVariantId,
          paymentStatus: '',
          specialRequest: specialRequest,
        });
      }
    }
    if (thisCart.length > 0) {
      for (let i = 0; i < thisCart.length; i++) {
        let this_item: PurchaseItem = thisCart[i];
        if (index !== i) {
          this_item = thisCart[i];
        } else if (index === i && quantity > 0) {
          this_item = { ...thisCart[i], quantity };
        }
        if ((quantity > 0 && index === i) || index !== i) {
          cartLineItems.push(this_item);
        }
      }
    }

    const purchaseCode = '';
    dispatch(
      updatePurchaseCartAsync({ CartLineItems: cartLineItems, purchaseCode })
    );
  };

  return (
    <div className="w-full space-y-4">
      <div
        className="font-bold text-[14px] font-dmsans 
        text-left text-primary-700
        "
      >
        Order Summary
      </div>

      {cart && cart.length > 0 && (
        <div
          className="w-full 
            bg-white py-4
            flex flex-col gap-[10px]
            border-y-[1px] border-y-secondary-100 border-solid
          "
        >
          <div className="max-h-[400px] px-4 overflow-auto">
            {cart &&
              cart.map((item: PurchaseItem, index: number) => {
                return (
                  <div key={`cartItem-${index}`}>
                    <div
                      className="flex justify-between gap-[15px]
                      relative"
                    >
                      {item.image && (
                        <div className="!w-[72px] h-[72px]">
                          <img
                            src={item.image}
                            alt={item.name}
                            className="!w-[72px] 
                          h-full rounded-md object-contain object-center "
                          />
                        </div>
                      )}
                      {item.name && (
                        <div
                          className="h-auto relative w-full 
                          flex flex-col flex-1 gap-[0px] 
                          justify-left text-center"
                        >
                          <div className="flex flex-row justify-between w-full">
                            <div className="flex flex-col w-full mb-2">
                              <div
                                className="flex flex-row 
                              gap-[30px] justify-between w-full"
                              >
                                <div
                                  className="font-dmsans text-left font-medium 
                                  text-[13px] leading-[20px] text-gray-900
                                  "
                                >
                                  {item.name}
                                </div>
                                {checkoutResponse === null &&
                                  anonymousCheckoutResponse === null && (
                                    <div className="">
                                      <div
                                        className="w-[20px] h-[20px] cursor-pointer content-center"
                                        onClick={() =>
                                          updateCartItemQuantity({
                                            quantity: 0,
                                            productVariantId:
                                              item.productVariantId,
                                            specialRequest: '',
                                            code: item.code,
                                            name: item.name,
                                            image: item.image,
                                            description: item.description,
                                            unitPrice: item.unitPrice,
                                          })
                                        }
                                      >
                                        <img
                                          src={closeIcon}
                                          className="w-[10px] h-[10px] m-auto"
                                        />
                                      </div>
                                    </div>
                                  )}
                              </div>
                              {item.sku && (
                                <div className="text-gray-500 text-left text-[10px]">
                                  {removeSkuPrefix(item.sku)}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="flex flex-row justify-between w-full">
                            <div
                              className="text-secondary-300 flex flex-row gap-x-1
                                    font-medium font-dmsans text-[12px]
                                    text-right"
                            >
                              {item.quantity} x
                              <span className="font-bold text-secondary-500">
                                {formatCurrency(item.unitPrice || 0)}
                              </span>
                            </div>
                            {checkoutResponse === null &&
                              anonymousCheckoutResponse === null && (
                                <div
                                  className="w-[80px] mr-2
                                    grid grid-cols-[18px_1fr_18px] place-self-center
                                    justify-between h-[20px] gap-[10px] place-center"
                                >
                                  <div
                                    className="w-[18px] 
                                    cursor-pointer font-regular
                                    text-black text-center rounded-md
                                    bg-white content-center px-[0.3px]
                                    hover:bg-secondary-200"
                                    onClick={() =>
                                      updateCartItemQuantity({
                                        quantity: item.quantity - 1,
                                        productVariantId: item.productVariantId,
                                        specialRequest: '',
                                        code: item.code,
                                        name: item.name,
                                        image: item.image,
                                        description: item.description,
                                        unitPrice: item.unitPrice,
                                      })
                                    }
                                  >
                                    <img src={MinusCircle} className="m-auto" />
                                  </div>
                                  <div
                                    className="h-[20px] leading-[20px] min-w-[30px]
                                      text-center text-primary-900 text-[10px] 
                                      font-bold"
                                  >
                                    {item.quantity}{' '}
                                  </div>
                                  <div
                                    className="w-[18px] 
                                    cursor-pointer font-regular
                                    text-black text-center rounded-md
                                    bg-white content-center px-[0.3px]
                                    hover:bg-secondary-200"
                                    onClick={() =>
                                      updateCartItemQuantity({
                                        quantity: item.quantity + 1,
                                        productVariantId: item.productVariantId,
                                        specialRequest: '',
                                        code: item.code,
                                        name: item.name,
                                        image: item.image,
                                        description: item.description,
                                        unitPrice: item.unitPrice,
                                      })
                                    }
                                  >
                                    <img src={AddCircle} className="m-auto" />
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="w-full h-[1px] bg-gray-50 my-[10px]" />
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
}
